import {makeAutoObservable} from 'mobx';

import type {Country} from './types';

export class CountryModel {
  private country: Country;

  constructor(country: Country) {
    this.country = country;

    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  get code() {
    return this.country.iso2;
  }

  get dialCode() {
    return this.country.dialCode;
  }

  get name() {
    return this.country.toString();
  }
}
